import classNames from 'classnames';
import PropTypes from 'prop-types';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import styles from './FJMobileObjectEraseEditFooter.module.less';
import FJUtil from '../../../util/FJUtil';
import FJConstant from '../../../constants/FJConstant';
import { useMemo } from 'react';
import UploadIcon from '../../../assets/svg/upload-black.svg?react';
import FJChooseObject from '../../../assets/svg/mobile-auto.svg?react';
import FJDrawIcon from '../../../assets/svg/draw.svg?react';
import FJEraseIcon from '../../../assets/svg/erase.svg?react';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import { MOUSE_EVENT_TYPE } from '../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJLocalStore from '../../../store/FJLocalStore';
import FJUndoIcon from '../../../assets/svg/undo.svg?react';
import FJRedoIcon from '../../../assets/svg/redo.svg?react';
import FJResetIcon from '../../../assets/svg/reset.svg?react';
import FJMobileSlider from '../../../common/components/FJMobileSlider/FJMobileSlider';
const MAX_SIZE = 42;
const MIN_SIZE = 8;
const editFunctionList = [
    {
        name: 'auto',
        icon: <FJChooseObject />,
        value: MOUSE_EVENT_TYPE.QUICK_SELECTION,
    },
    {
        name: 'draw',
        icon: <FJDrawIcon />,
        value: MOUSE_EVENT_TYPE.MASK_DRAW,
    },
    {
        name: 'erase',
        icon: <FJEraseIcon />,
        value: MOUSE_EVENT_TYPE.MASK_ERASE,
    },
];
const FJMobileObjectEraseEditFooter = props => {
    const {
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        isProjectLoading,
        uploadImg,
        curBrushType,
        setCurBrushType,
        hasUndo,
        hasRedo,
        disableReset,
        undoHandler,
        redoHandler,
        resetHandler,
        changeBrashSize,
        minBrashSize = MIN_SIZE,
        maxBrashSize = MAX_SIZE,
        brashSize,
    } = props;
    const isDisabled = useMemo(() => {
        return FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR;
    }, [taskStatus]);

    const useCredit = 3;
    const isFree = freeNumCreation > 0 && useCredit > creditNumber;
    const text = useMemo(() => {
        if (taskStatus === FJConstant.START) {
            return 'start';
        } else if (taskStatus === FJConstant.GENERATING) {
            return 'removing';
        }
        return 'remove';
    }, [taskStatus]);
    return (
        <div className={classNames(styles.container, isDisabled && styles.disabled)}>
            <div className={styles.header}>
                <div className={styles.left}>
                    <div
                        className={classNames(styles.left_item, {
                            [styles.disabled]: !hasUndo,
                        })}
                        onClick={undoHandler}
                    >
                        <FJUndoIcon />
                    </div>
                    <div
                        className={classNames(styles.left_item, {
                            [styles.disabled]: !hasRedo,
                        })}
                        onClick={redoHandler}
                    >
                        <FJRedoIcon />
                    </div>
                </div>

                <div
                    className={classNames(styles.right_item, {
                        [styles.disabled]: disableReset,
                    })}
                    onClick={resetHandler}
                >
                    <FJResetIcon />
                </div>
            </div>
            <div className={styles.edit_box}>
                {editFunctionList.map(item => {
                    return (
                        <FJHoverBoardGradation
                            key={item.value}
                            contentClassName={styles.edit_item_content}
                            className={classNames(styles.upscaler_item, {
                                [styles.active]: item.value === curBrushType,
                            })}
                            active={item.value === curBrushType}
                            onClick={() => {
                                setCurBrushType(item.value);
                            }}
                            selectBgColor={'#fff'}
                        >
                            {item.icon}
                            <div className={styles.edit_item_text}>{FJLocalStore._(item.name)}</div>
                        </FJHoverBoardGradation>
                    );
                })}
            </div>
            <div
                className={classNames(styles.slider_box, {
                    [styles.show]: MOUSE_EVENT_TYPE.QUICK_SELECTION !== curBrushType,
                })}
            >
                <span className={styles.slider_text}>{FJLocalStore._('size')}</span>
                <FJMobileSlider
                    className={classNames(styles.slider, {
                        [styles.disabled]: false,
                    })}
                    max={maxBrashSize}
                    min={minBrashSize}
                    value={brashSize}
                    onChange={changeBrashSize}
                />
            </div>
            <div className={styles.btn_box}>
                <FJFileUpload
                    className={classNames(styles.upload_box, isDisabled && styles.disabled)}
                    onUpload={uploadImg}
                >
                    <UploadIcon />
                </FJFileUpload>
                <FJGenerateButton
                    className={styles.generate_btn}
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    text={text}
                />
            </div>
        </div>
    );
};

FJMobileObjectEraseEditFooter.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    uploadImg: PropTypes.func,
    curBrushType: PropTypes.string,
    setCurBrushType: PropTypes.func,
    hasUndo: PropTypes.bool,
    hasRedo: PropTypes.bool,
    disableReset: PropTypes.bool,
    undoHandler: PropTypes.func,
    redoHandler: PropTypes.func,
    resetHandler: PropTypes.func,
    changeBrashSize: PropTypes.func,
    maxBrashSize: PropTypes.number,
    minBrashSize: PropTypes.number,
    brashSize: PropTypes.number,
};
export default FJMobileObjectEraseEditFooter;
